import { echoService } from '../../services/echo.service'
import axios from 'axios'
import findKey from 'lodash/findKey'

let lastCommited = null

export const initializeWebsocket = ({ commit }) => {
  echoService.initialize()
}

export const subscribeToTraining = ({ commit, state }, { userId, handlers }) => {
  if (state.activeConnections.has(userId)) {
    echoService.unsubscribeFromTraining(userId)

  }
  const connection = echoService.subscribeToTraining(userId)

  connection.listenForWhisper('trainingData', async (e) => {
    const key = findKey(state.liveSporters, { 'user_id': e.user.uuid })
    console.log('Training data received:', e, key)

    if (key === undefined) {
      // Initialize new sporter with complete data
      const sporter = {
        user: e.user,
        user_id: e.user.uuid,
        hr: (e.data ? e.data.hr[e.data.hr.length - 1][1] : 0),
        amp: (e.data ? e.data.amp[e.data.amp.length - 1][1] : 0),
        bf: (e.data ? e.data.bf[e.data.bf.length - 1][1] : 0),
        training: e.training,
        time: e.time,
        trainingTime: e.data.hr[0],
        weight: 0,
        watts: 0,
        lastO2: 0,
        lastO2KG: 0,
        zone: (e.data ? handlers.setZoneText(e.data.zone[e.data.zone.length - 1][1]) : ''),
        shown: false,
        chartData: {
          heartrate: [[handlers.parseTime(e.data.hr[0]), e.data.hr[1]]],
          amplitude: [[handlers.parseTime(e.data.amp[0]), parseInt(e.data.amp[1])]],
          breathfrequency: [[handlers.parseTime(e.data.bf[0]), e.data.bf[1]]],
          breathsignal: [[handlers.parseTime(e.data.breath[0]), e.data.breath[1]]],
          heartratetime: [[handlers.parseTime(e.data.hrt[0]), e.data.hrt[1]]],
          zone: [[handlers.parseTime(e.data.zone[0]), e.data.zone[1]]],
          watts: [[handlers.parseTime(e.data.zone[0]), 0]]
        },
        lastTrainingTime: 0
      }

      try {
        const request = await axios.get(`/api/user/user-weight/${e.user.uuid}`)
        sporter.weight = request.data.data.weight
      } catch (error) {
        console.error('Error fetching user weight:', error)
      }
      if (lastCommited !== sporter.user_id) {
        commit('ADD_LIVE_SPORTER', sporter)
        lastCommited = sporter.user_id
      }
    } else {
      // Update existing sporter
      const sporter = { ...state.liveSporters[key] }

      sporter.hr = (e.data ? e.data.hr[1] : 0)
      sporter.amp = (e.data ? e.data.amp[1] : 0)
      sporter.bf = (e.data ? e.data.bf[1] : 0)
      sporter.time = e.time
      sporter.trainingTime = e.data.hr[0]
      sporter.zone = handlers.setZoneText ? handlers.setZoneText(e.data.zone[1]) : ''



      if (e.data && e.data.hr[1] != null) {
        if (e.data.hr[0] < sporter.lastTrainingTime) {
          sporter.chartData = null
          sporter.lastTrainingTime = e.data.hr[0]
        } else {
          sporter.chartData = {
            ...sporter.chartData,
            heartrate: [...sporter.chartData.heartrate, [e.data.hr[0], e.data.hr[1]]],
            amplitude: [...sporter.chartData.amplitude, [e.data.amp[0], parseInt(e.data.amp[1])]],
            breathfrequency: [...sporter.chartData.breathfrequency, [e.data.bf[0], e.data.bf[1]]],
            breathsignal: [...sporter.chartData.breathsignal, [e.data.breath[0], e.data.breath[1]]],
            heartratetime: [...sporter.chartData.heartratetime, [e.data.hrt[0], e.data.hrt[1]]],
            zone: [...sporter.chartData.zone, [e.data.zone[0], e.data.zone[1]]],
            watts: [...sporter.chartData.watts, [e.data.zone[0], 0]]
          }
        }
      }

      commit('UPDATE_LIVE_SPORTER', { key, sporter })
    }

    if (handlers.onTrainingData) {
      // console.log(sporter)
    }
  })

  commit('ADD_CONNECTION', { userId, connection })
}

export const unsubscribeFromTraining = ({ commit }, userId) => {
  echoService.unsubscribeFromTraining(userId)
  commit('REMOVE_CONNECTION', userId)
}
